/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 05-11-2026 12:02:02

export enum ResultaatBijzonderheid {
    TELT_NIET_MEE = "Telt niet mee",
    VRIJSTELLING = "Vrijstelling",
    NIET_GEMAAKT = "Niet gemaakt"
}
